export default __webpack_public_path__ + "static/careers-benefits-block1-icon01.url-ffcb6f3bf3ff2c2aabaa7976593d5566.svg";